export default __webpack_public_path__ + "static/media/dhl-logo-2.0462ec3b.png";